const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_BACKDROP':
			return {...state, active: action.active}
		default: // need this for default case
      		return state ;
    }
}

export default reducer;